const FETCH_USER_NOTIFICATIONS = 'header/getUserNotifications/FETCH_USER_NOTIFICATIONS';
const FETCH_USER_NOTIFICATIONS_SUCCESS = 'header/getUserNotifications/FETCH_USER_NOTIFICATIONS_SUCCESS';
const FETCH_USER_NOTIFICATIONS_ERROR = 'header/getUserNotifications/FETCH_USER_NOTIFICATIONS_ERROR';

const DISMISS_USER_NOTIFICATION = 'header/dismissUserNotification/DISMISS_USER_NOTIFICATION';
const DISMISS_USER_NOTIFICATION_SUCCESS = 'header/dismissUserNotification/DISMISS_USER_NOTIFICATION_SUCCESS';
const DISMISS_USER_NOTIFICATION_ERROR = 'header/dismissUserNotification/DISMISS_USER_NOTIFICATION_ERROR';

export {
  FETCH_USER_NOTIFICATIONS,
  FETCH_USER_NOTIFICATIONS_SUCCESS,
  FETCH_USER_NOTIFICATIONS_ERROR,
  DISMISS_USER_NOTIFICATION,
  DISMISS_USER_NOTIFICATION_SUCCESS,
  DISMISS_USER_NOTIFICATION_ERROR
};
